/**
 * GraphQL queries for appointment scheduling
 */

export const GET_ALL_RESOURCES = `
  query getAllResources {
    pep_vw_user_dashboard {
      email
      id
      user_name
      user_type
    }
  }
`;

export const GET_CLINIC_FACILITIES = `
  query getClinicFacilities($clinicId: Int!) {
    emr_clinic_facility(where: {clinic_id: {_eq: $clinicId}, is_active: {_eq: true}}) {
      clinic_id
      facility_name
      clinic_facility_id
    }
  }
`;
